import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AlertRelatedResponse } from '@/types/alertDetail';

/**
 * GET /api/v1/alerts/{id}/related
 *
 * Returns alerts on the same asset/card/attendant in the last 30 days
 * (excluding the focus alert). Drives the RelatedAlertsSection table
 * with `match_reason` chips.
 */
export function useAlertRelated(
  alertId: number | undefined,
): UseQueryResult<AlertRelatedResponse, Error> {
  return useQuery<AlertRelatedResponse, Error>({
    queryKey: ['alert', alertId, 'related'],
    enabled: alertId != null,
    queryFn: async () => {
      const resp = await api.get<AlertRelatedResponse>(
        `/alerts/${alertId}/related`,
      );
      return resp.data;
    },
  });
}
